(function () {
  'use strict';

  var imageSelector = [
    '.mn-aesop-image-frame img',
    '.mn-aesop-main-image-frame img',
    '.mn-aesop-thumb-frame img',
    '.mn-aesop-related-frame img'
  ].join(',');

  var supportedCollectionSelector = [
    '.mn-shop-category-page[data-mn-shop-group="aesop"]',
    '.mn-shop-category-page[data-mn-shop-group="perfumery"]',
    '.mn-shop-category-page[data-mn-shop-group="beauty"]'
  ].join(',');

  function normalise(value) {
    return (value || '').toString().toLowerCase();
  }

  function productIdentity(card, wrapper, image) {
    var link = null;

    if (card && card.matches && card.matches('a[href*="/products/"]')) {
      link = card;
    } else if (card && card.querySelector) {
      link = card.querySelector('a[href*="/products/"]');
    }

    if (!link && wrapper && wrapper.closest) {
      link = wrapper.closest('a[href*="/products/"]');
    }

    var titleNode = card && card.querySelector ? card.querySelector('.h6, h3, [data-product-title]') : null;

    return normalise([
      link ? link.getAttribute('href') : '',
      titleNode ? titleNode.textContent : '',
      image ? image.getAttribute('alt') : '',
      wrapper ? wrapper.getAttribute('data-vendor') : '',
      card ? card.getAttribute('data-vendor') : ''
    ].join(' '));
  }

  function isAesopProduct(identity, group) {
    return group === 'aesop' || identity.indexOf('aesop') !== -1;
  }

  function markAesopCards(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var pages = [];

    if (scope.matches && scope.matches(supportedCollectionSelector)) {
      pages.push(scope);
    }

    if (scope.closest) {
      var parentPage = scope.closest(supportedCollectionSelector);
      if (parentPage && pages.indexOf(parentPage) === -1) pages.push(parentPage);
    }

    scope.querySelectorAll(supportedCollectionSelector).forEach(function (page) {
      if (pages.indexOf(page) === -1) pages.push(page);
    });

    pages.forEach(function (page) {
      var group = normalise(page.getAttribute('data-mn-shop-group'));

      page.querySelectorAll('.collection-card, [data-product-card], .boost-pfs-filter-product-item').forEach(function (card) {
        var wrapper = card.querySelector && card.querySelector(
          '.blog33_image-wrapper-2, .gallery21_image-wrapper, .boost-pfs-filter-product-item-image-link'
        );

        if (!wrapper) return;

        var image = wrapper.querySelector('img');
        var identity = productIdentity(card, wrapper, image);

        if (!isAesopProduct(identity, group)) return;

        wrapper.classList.add('mn-aesop-image-frame');
        wrapper.setAttribute('data-mn-aesop-fixed', 'true');

        if (identity.indexOf('refresh-body-cleansing-slab') !== -1) {
          wrapper.classList.add('mn-aesop-cleansing-slab-frame');
        }
      });
    });
  }

  function ensureRelatedMediaFrames(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var cards = [];

    if (scope.matches && scope.matches('.mn-aesop-related-frame')) cards.push(scope);
    scope.querySelectorAll('.mn-aesop-related-frame').forEach(function (card) {
      if (cards.indexOf(card) === -1) cards.push(card);
    });

    cards.forEach(function (card) {
      if (card.querySelector('.mn-aesop-related-media-frame')) return;

      var image = null;
      Array.prototype.some.call(card.children, function (child) {
        if (child.matches && child.matches('img.mn-aesop-related-image')) {
          image = child;
          return true;
        }
        return false;
      });

      if (!image) return;

      var frame = document.createElement('div');
      frame.className = 'mn-aesop-related-media-frame';

      var href = normalise(card.getAttribute('href'));
      if (href.indexOf('refresh-body-cleansing-slab') !== -1) {
        frame.classList.add('mn-aesop-cleansing-slab-frame');
      }

      card.insertBefore(frame, image);
      frame.appendChild(image);
    });
  }

  function applyProductSpecificClass(image) {
    if (!image) return;

    image.classList.remove(
      'mn-aesop-slab-150g-image',
      'mn-aesop-slab-310g-image'
    );

    var productLink = image.closest && image.closest('a[href*="/products/"]');
    var productPath = productLink ? productLink.getAttribute('href') : '';

    if (!productPath || productPath.indexOf('/products/') === -1) {
      productPath = window.location.pathname || '';
    }

    productPath = normalise(productPath);

    if (productPath.indexOf('aesop-refresh-body-cleansing-slab-150g') !== -1) {
      image.classList.add('mn-aesop-slab-150g-image');
    } else if (productPath.indexOf('aesop-refresh-body-cleansing-slab-310g') !== -1) {
      image.classList.add('mn-aesop-slab-310g-image');
    }
  }

  function classify(image) {
    if (!image) return;

    applyProductSpecificClass(image);

    if (!image.naturalWidth || !image.naturalHeight) return;

    image.classList.remove(
      'mn-aesop-source-landscape',
      'mn-aesop-source-square',
      'mn-aesop-source-portrait'
    );

    var ratio = image.naturalWidth / image.naturalHeight;

    if (ratio >= 1.08) {
      image.classList.add('mn-aesop-source-landscape');
    } else if (ratio >= 0.92) {
      image.classList.add('mn-aesop-source-square');
    } else {
      image.classList.add('mn-aesop-source-portrait');
    }
  }

  function initialise(root) {
    var scope = root && root.querySelectorAll ? root : document;

    markAesopCards(scope);
    ensureRelatedMediaFrames(scope);

    if (scope.matches && scope.matches(imageSelector)) {
      if (scope.complete) classify(scope);
      scope.addEventListener('load', function () { classify(scope); }, { once: true });
    }

    scope.querySelectorAll(imageSelector).forEach(function (image) {
      if (image.complete) classify(image);
      image.addEventListener('load', function () { classify(image); }, { once: true });
    });
  }

  function start() {
    initialise(document);

    if ('MutationObserver' in window) {
      new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          mutation.addedNodes.forEach(function (node) {
            if (node.nodeType !== 1) return;
            initialise(node);
          });
        });
      }).observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
}());
